import React from "react";
import Violations from "../Library/Violations";

export const IN_POLICY_APPROVAL = "In Policy booking requires approval";

const IN_POLICY_NOTICES = ["in policy booking requires approval", "approval rule was triggered"];

const noticeText = (item) => String(item || "").trim().toLowerCase();

export const policyBreaches = (violations = []) => (Array.isArray(violations) ? violations : []).filter((item) => !IN_POLICY_NOTICES.includes(noticeText(item)));

export const inPolicyNotices = (violations = []) => (Array.isArray(violations) ? violations : []).filter((item) => IN_POLICY_NOTICES.includes(noticeText(item)));

export const isOutOfPolicy = (violations) => policyBreaches(violations).length > 0;

export const APPROVAL_COPY = {
	IN_POLICY: "In policy booking requires approval",
	OUT_POLICY: "Out of policy booking requires approval",
	AMOUNT: "This amount requires approval",
};

// Limits and approval are separate. A matched rule is the only path that can ask someone.
// Inside limits + no rule: book without approval.
// Inside limits + rule: ask for approval.
// Outside limits + rule: ask for approval.
// Outside limits + no rule: the booking is not allowed. "No approval" does not apply here.
export function resolveFarePolicy({ withinLimits, approvalRequired, approvalWhen, violations = [], inPolicy } = {}) {
	const messages = violations || [];
	const limitViolations = messages.filter((item) => item !== IN_POLICY_APPROVAL);
	const hasInPolicySentence = messages.includes(IN_POLICY_APPROVAL);
	const limitsPassed = typeof withinLimits === "boolean" ? withinLimits : limitViolations.length === 0 && (inPolicy !== false || hasInPolicySentence);
	const knowsApproval = typeof approvalRequired === "boolean" || hasInPolicySentence;
	const needsApproval = typeof approvalRequired === "boolean" ? approvalRequired : hasInPolicySentence;

	let approvalState = "unknown";
	if (needsApproval) approvalState = "required";
	else if (knowsApproval && limitsPassed) approvalState = "none";
	else if (knowsApproval && !limitsPassed) approvalState = "blocked";

	return { limitsPassed, needsApproval, knowsApproval, approvalState, approvalWhen, limitViolations };
}

export function fareDecision(fare, { isTravelAdmin = false, approvedAmount } = {}) {
	const status = resolveFarePolicy(fare || {});
	const coveredByApproval = approvedAmount != null && approvedAmount !== "" && Number(fare?.price) <= Number(approvedAmount);
	const askApproval = !isTravelAdmin && !coveredByApproval && (status.approvalState === "required" || (status.approvalState === "unknown" && fare?.inPolicy === false));
	const blocked = !isTravelAdmin && !coveredByApproval && status.approvalState === "blocked";
	return { ...status, askApproval, blocked };
}

export function approvalIntro(fare, violations = []) {
	const { limitsPassed } = resolveFarePolicy({ ...fare, violations });
	if (limitsPassed) {
		return "This fare is inside policy and needs approval. You can send a request to your manager.";
	}
	return "This fare is outside policy and needs approval. You can send a request to your manager.";
}

export function ApprovalNotes({ fare, violations = [] }) {
	const { limitsPassed, needsApproval, approvalWhen, limitViolations } = resolveFarePolicy({ ...fare, violations });
	const approvalText = APPROVAL_COPY[approvalWhen] || (violations.includes(IN_POLICY_APPROVAL) ? "In policy booking requires approval" : "Approval is required");

	return (
		<>
			{!limitsPassed && limitViolations.length > 0 && (
				<Violations violations={limitViolations} heading={limitViolations.length === 1 ? "Policy limit" : `${limitViolations.length} Policy limits`} />
			)}
			{needsApproval && <Violations violations={[approvalText]} heading="Approval" tone="warning" className={!limitsPassed && limitViolations.length > 0 ? "mt-2" : ""} />}
		</>
	);
}

export function PolicyBlockNotice({ fare }) {
	const { limitViolations } = resolveFarePolicy(fare || {});
	const reason = limitViolations[0];
	return (
		<div className="p-3 text-sm rounded-md bg-danger text-dangerText">
			{reason ? `${reason}. ` : "This fare is outside policy. "}
			No approval rule covers it, so this booking is not allowed.
		</div>
	);
}
